import { brandedUuid } from '../FlavorSchema.js';
export const BatchJobIdSchema = brandedUuid('Invalid batch job ID format');
export const BatchJobLineIdSchema = brandedUuid('Invalid batch job line ID format');
//# sourceMappingURL=BatchSchemas.js.map